import * as React from "react";
import classNames from "classnames";

type Props = {
	type?: "submit" | "reset" | "button";
	onClick: () => void;
	text: string;
	small?: boolean;
	disabled?: boolean;
};

class ButtonInverted extends React.PureComponent<Props> {
	public render() {
		return (
			<button
				className={classNames('btn', 'btn__inverted', this.props.small && 'small')}
				type={this.props.type || "button"}
				onClick={e => {
					e.preventDefault();
					this.props.onClick();
				}}
				disabled={this.props.disabled}
			>
				{this.props.text}
			</button>
		);
	}
}

export default ButtonInverted;
